// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary-module_wrapper__v7au0"};